import { sharedFiltersService } from '@/services';

export default {
  async fetchList({ commit, dispatch }, params) {
    try {
      const list = await sharedFiltersService.list(params);
      const isAppending = params.page > 1;

      commit('SET_FILTERS_LIST', list);
    } catch ({ message }) {
      console.error(message);
    }
  },
  async createOne({ commit, dispatch }, params) {
    try {
      await sharedFiltersService.createOne(params);
    } catch ({ message }) {
      console.error(message);
    }
  },
  async updateOne({ commit, dispatch }, params) {
    try {
      await sharedFiltersService.updateOne(params);
    } catch ({ message }) {
      console.error(message);
    }
  },
  async deleteOne({ commit, dispatch }, params) {
    try {
      await sharedFiltersService.deleteOne(params);
    } catch ({ message }) {
      console.error(message);
    }
  },
};
